import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FILE_DOWNLOAD } from '../../apiRoutes'
import { getAccessToken } from '../../services/keycloakService'

const normalizeFilePath = (filePath = '') => String(filePath).replace(/\\/g, '/')

const AuthenticatedFileImage = ({
  fileName,
  filePath,
  endpoint = FILE_DOWNLOAD,
  children,
}) => {
  const [imageSrc, setImageSrc] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let isActive = true
    let objectUrl = null

    const loadImage = async () => {
      if (!filePath) {
        setImageSrc(null)
        return
      }

      setLoading(true)

      try {
        const token = getAccessToken()
        const params = new URLSearchParams({
          file_path: normalizeFilePath(filePath),
        })

        if (fileName) {
          params.set('file_name', fileName)
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
          method: 'GET',
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        })

        if (!response.ok) {
          throw new Error(`Image load failed with status ${response.status}`)
        }

        const blob = await response.blob()
        objectUrl = window.URL.createObjectURL(blob)

        if (isActive) {
          setImageSrc(objectUrl)
        }
      } catch {
        if (isActive) {
          setImageSrc(null)
        }
      } finally {
        if (isActive) {
          setLoading(false)
        }
      }
    }

    loadImage()

    return () => {
      isActive = false
      if (objectUrl) {
        window.URL.revokeObjectURL(objectUrl)
      }
    }
  }, [endpoint, fileName, filePath])

  return children({ imageSrc, loading })
}

AuthenticatedFileImage.propTypes = {
  fileName: PropTypes.string,
  filePath: PropTypes.string,
  endpoint: PropTypes.string,
  children: PropTypes.func.isRequired,
}

export default AuthenticatedFileImage